import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import timesUp from "../../../template/images/timesup.png";

export default function CountdownTimer(props) {
    console.log("rem time", props.time)
    const [showModal, setShowModal] = useState(false);
    const { ass_id } = useParams();
    const navigate = useNavigate();
    const currentDate = new Date();
    let storedTime = localStorage.getItem('remainingTime');
    let datas = moment(currentDate).add(props.time, 'seconds').format('DD MMM YYYY HH:mm:ss');
    const [expiryTime, setExpiryTime] = useState(datas);
    const [countdownTime, setCountdownTime] = useState({
        countdownHours: '',
        countdownMinutes: '',
        countdownSeconds: ''
    });

    const countdownTimer = () => {
        const timeInterval = setInterval(() => {
            const countdownDateTime = new Date(expiryTime).getTime();
            const currentTime = new Date().getTime();
            const remainingTime = countdownDateTime - currentTime;
            const totalHours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const totalMinutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
            const totalSeconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

            const runningCountdownTime = {
                countdownHours: totalHours,
                countdownMinutes: totalMinutes,
                countdownSeconds: totalSeconds
            };
            setCountdownTime(runningCountdownTime);
            localStorage.setItem('remainingTime', Math.floor(remainingTime / 1000));

            if (remainingTime < 0) {
                clearInterval(timeInterval);
                setExpiryTime(false);
                setShowModal(true);
                localStorage.removeItem('remainingTime');
                setCountdownTime({
                    countdownHours: 0,
                    countdownMinutes: 0,
                    countdownSeconds: 0
                });
            }

            // console.log(totalHours, totalMinutes, totalSeconds, "count running");
        }, 1000);
    };

    useEffect(() => {
        countdownTimer();
    }, []);

    const handleGoBack = () => {
        navigate('/Quiz');
    };

    return (
        <div>
            <div className='countdownTime'>
                <div className='col'>
                    <div className='d-flex timer_clock'>
                        <span className="">{countdownTime.countdownHours}</span>
                        <span className="">:</span>
                        <span className="">{countdownTime.countdownMinutes}</span>
                        <span className="">:</span>
                        <span className="">{countdownTime.countdownSeconds}</span>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={handleGoBack} centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body className='time-up-modal'>
                    <img src={timesUp} alt="" />
                    <h2> Time's Up!</h2>
                    <p>Your time for this quiz has ended.</p>
                    </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleGoBack} className="footer-main">
                        Go Back
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
